
/**
 * 현재 사용자의 투표 상태
 */
export type GetReview200AllOfTwoUserVote = typeof GetReview200AllOfTwoUserVote[keyof typeof GetReview200AllOfTwoUserVote];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetReview200AllOfTwoUserVote = {
  HELPFUL: 'HELPFUL',
  UNHELPFUL: 'UNHELPFUL',
  NONE: 'NONE',
} as const;
